import { render, staticRenderFns } from "./BenefitCard.vue?vue&type=template&id=b6613f1c&scoped=true"
import script from "./BenefitCard.vue?vue&type=script&lang=js"
export * from "./BenefitCard.vue?vue&type=script&lang=js"
import style0 from "./BenefitCard.vue?vue&type=style&index=0&id=b6613f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6613f1c",
  null
  
)

export default component.exports